import React from 'react';

export function AppsTab() {
  return (
    <div className="space-y-4">
      <p className="text-sm font-medium" style={{ color: 'var(--color-text)' }}>
        Apps
      </p>
      <p className="text-xs" style={{ color: 'var(--color-text)', opacity: 0.6 }}>
        App integrations coming soon.
      </p>
    </div>
  );
}
